// biome-ignore lint/correctness/noUnusedFunctionParameters: props parameter may be used in future features
export const styles = (theme, props) => ({
  label: {
    ...theme.palette.alternateText,
    fontSize: '10px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.5,
  },
  spaceBetween: {
    padding: '10px 20px',
    borderTop: 'solid rgba(0, 0, 0, 0.12) thin',
    display: 'flex',
    justifyContent: 'space-between',
    flexShrink: 0,
    backgroundColor: '#fff',
  },
  buttonsContainer: {
    padding: '10px 0 10px 10px',
  },
  button: {
    ...theme.palette.button,
    height: '100%',
    width: '128px',
  },
  placeholderContent: {
    minHeight: '200px',
    width: '100%',
  },
  modalContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '400px',
    maxHeight: 'calc(85vh - 100px)',
    overflow: 'hidden',
  },
  templateListScrollContainer: {
    overflowY: 'auto',
    flexGrow: 1,
    padding: '0',
    backgroundColor: 'transparent',
    borderTop: '1px solid #e0e0e0',
    minHeight: '1px',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#c1c1c1',
      borderRadius: '4px',
    },
  },
  formControlRow: {
    display: 'flex',
    alignItems: 'center',
  },
  boxFlex: {
    display: 'flex',
  },
  templateItem: {
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    cursor: 'pointer',
    background: 'transparent',
    transition: 'background 0.2s, border 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  templateItemSelected: {
    border: '2px solid #1976d2',
    background: 'rgba(25, 118, 210, 0.08)',
  },
  templateListTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  // Portfolio Summary styles
  portfolioSummaryTitle: {
    fontWeight: 'bold',
    fontStyle: 'italic',
    mb: 1,
    fontSize: '0.9rem',
  },
  portfolioSummaryTable: {
    border: '1px solid #ddd',
    borderRadius: '3px',
    overflow: 'hidden',
  },
  portfolioSummaryHeader: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    backgroundColor: '#2c3e50',
    color: 'white',
  },
  portfolioSummaryHeaderCell: {
    padding: '2px',
    textAlign: 'center',
    borderRight: '1px solid #34495e',
  },
  portfolioSummaryHeaderCellLast: {
    padding: '2px',
    textAlign: 'center',
  },
  portfolioSummaryHeaderText: {
    fontWeight: 'bold',
    fontSize: '0.6rem',
  },
  portfolioSummaryData: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    backgroundColor: '#ecf0f1',
  },
  portfolioSummaryDataCell: {
    padding: '3px',
    textAlign: 'center',
    borderRight: '1px solid #ddd',
  },
  portfolioSummaryDataCellLast: {
    padding: '3px',
    textAlign: 'center',
  },
  portfolioSummaryDataText: {
    fontWeight: 'bold',
    fontSize: '0.8rem',
  },
  // Selected Filters styles
  selectedFiltersTitle: {
    fontWeight: 'bold',
    fontStyle: 'italic',
    mb: 1,
    fontSize: '0.9rem',
  },
  selectedFiltersLabel: {
    fontWeight: 'bold',
    fontSize: '0.8rem',
  },
  selectedFiltersValue: {
    fontSize: '0.8rem',
    display: 'block',
  },
  // Information Box styles
  infoBox: {
    backgroundColor: '#d4e6f5',
    borderRadius: '6px',
    padding: '8px',
    border: '1px solid #b3d1e6',
  },
  infoBoxContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 0.5,
  },
  infoBoxIcon: {
    width: 14,
    height: 14,
    borderRadius: '50%',
    backgroundColor: '#5b9bd5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    mt: 0.1,
  },
  infoBoxIconText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '9px',
  },
  infoBoxText: {
    color: '#2c5f8d',
    fontSize: '0.7rem',
    fontStyle: 'italic',
  },
  // Adjustable Inputs styles
  adjustableInputsTitle: {
    fontWeight: 'bold',
    fontStyle: 'italic',
    mb: 0.5,
    fontSize: '0.75rem',
  },
  adjustableInputsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '0.5rem',
    pl: 1,
  },
  adjustableInputsItem: {
    fontSize: '0.7rem',
    display: 'block',
  },
  // Customize File Name styles
  customizeFileNameLabel: {
    ...theme.palette.alternateText,
    textTransform: 'uppercase',
    color: '#5b9bd5',
    fontSize: '0.65rem',
  },
  customizeFileNameField: {
    mt: 0.3,
    width: '60%',
  },
  // Modal content styles
  modalContent: {
    flex: 1,
    overflowY: 'auto',
    padding: '0 20px 20px 20px',
  },
});
